<template>
  <div
    ref="show-card-list"
    :data-segment-uuid="shows.uuid"
    class="show-card-list"
    data-test="show-card-list">
    <div class="draggable-element">
      <picture-component :src="shows.display_image_url || (shows && shows.season && shows.season.podcast && shows.season.podcast.image_url) || showDisplayImageUrl"/>
      <p class="small-text">{{ shows.title | truncate(30) }}</p>
    </div>
    <div :class="`main-content ${noBorder ? 'without-border' : ''}`">
      <div class="tags">
        <!--  -->
        <FreeEpisodeIndicator v-if="isFree && !isPremiumMember" />
        <PremiumIndicator v-if="showPremiumIndicator" />
        <!--  -->
      </div>
      <el-row
        type="flex"
        class="d-flex-wrap">
        <div class="show-play-button">
          <el-progress
            v-show="playerIcon === playIcon || playerIcon === pauseIcon || isLoading"
            :percentage="Number(currentProgress)"
            :stroke-width="2"
            :width="42"
            :show-text="false"
            type="circle"
            color="#00AECB"
            @click.native="playerIcon === playIcon ? playEpisode() : playerIcon === pauseIcon ? pauseEpisode(): ''"/>
          <svg v-if="playerIcon === playIcon" data-test="btn-playepisode" class="play-button" svg-inline="" @click="playEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 121 156"><defs><path id="ic_play_blue_svg__a" d="M496.406096,345.69723 C491.541695,349.359203 485.132833,350.027479 479.65336,347.444103 C474.173887,344.860725 470.480935,339.429801 470,333.247692 L470,208.752308 C470.480935,202.570199 474.173887,197.139275 479.65336,194.555898 C485.132833,191.972521 491.541695,192.640797 496.406096,196.30277 L584.381047,258.550462 C588.505275,261.268282 591,265.960591 591,271 C591,276.039409 588.505275,280.731718 584.381047,283.449538 L496.406096,345.69723 Z"/></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-470.000000, -193.000000)"><use fill="#00AECB" xlink:href="#ic_play_blue_svg__a"/></g></g></svg>
          <svg v-if="playerIcon === pauseIcon" data-test="btn-pauseepisode" class="pause-button" svg-inline="" @click="pauseEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 24"><defs><path id="ic_pause_blue_svg__a" d="M611.666667,209 L616.333334,209 C616.885618,209 617.333334,209.447715 617.333334,210 L617.333334,232 C617.333334,232.552285 616.885618,233 616.333334,233 L611.666667,233 C611.114382,233 610.666667,232.552285 610.666667,232 L610.666667,210 C610.666667,209.447715 611.114382,209 611.666667,209 Z M623.666667,209 L628.333334,209 C628.885618,209 629.333334,209.447715 629.333334,210 L629.333334,232 C629.333334,232.552285 628.885618,233 628.333334,233 L623.666667,233 C623.114382,233 622.666667,232.552285 622.666667,232 L622.666667,210 C622.666667,209.447715 623.114382,209 623.666667,209 Z"/></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-610.000000, -209.000000)"><use fill="#00AECB" xlink:href="#ic_pause_blue_svg__a"/></g></g></svg>
          <svg v-if="playerIcon === replayIcon" class="replay-button" svg-inline="" @click="replayEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 44"><defs><path id="ic_replay_blue_svg__a" d="M17.2802001,31.1473435 C16.7584662,31.5390313 16.0710801,31.6105108 15.4833763,31.3341905 C14.8956726,31.0578702 14.4995829,30.4769738 14.448,29.8157299 L14.448,16.4995939 C14.4995829,15.83835 14.8956726,15.2574536 15.4833763,14.9811333 C16.0710801,14.704813 16.7584662,14.7762925 17.2802001,15.1679803 L26.7160009,21.8260483 C27.1583473,22.1167487 27.4259203,22.6186422 27.4259203,23.1576619 C27.4259203,23.6966816 27.1583473,24.1985751 26.7160009,24.4892755 L17.2802001,31.1473435 Z"/></defs><g fill="none" fill-rule="evenodd"><g><g transform="translate(-595.000000, -200.000000) translate(595.406000, 200.043583)"><path fill="#AFE7F1" d="M19.5613044,43.344 C30.3474247,43.344 39.1225044,34.6205 39.1225044,23.8979621 C39.1225044,18.9986762 37.2823071,14.3166378 33.940987,10.7144563 C30.6028016,7.11589025 26.0708025,4.91502381 21.1798755,4.51742804 L19.8815704,4.41183494 L19.8815704,-3.55271368e-15 L10.9786979,5.31527801 L19.8815704,10.630556 L19.8815704,6.11387235 L21.4359839,6.27593064 C25.7880489,6.72977892 29.8073089,8.76646032 32.7532337,12.0107099 C35.7176535,15.27527 37.3502265,19.4968672 37.3502265,23.8979621 C37.3502265,33.6683544 29.3701171,41.617186 19.5613044,41.617186 C9.7524918,41.617186 1.77238239,33.6683544 1.77238239,23.8979621 C1.77238239,19.3387434 3.50683442,15.0075123 6.65620391,11.702225 C6.81461281,11.5359132 6.89862386,11.3195164 6.89266785,11.0929113 C6.88671185,10.8654555 6.79099776,10.6529932 6.62318464,10.4946567 C6.45004247,10.3313224 6.22810283,10.2502933 6.00668564,10.2502933 C5.76949026,10.2502933 5.53302632,10.3432322 5.35748084,10.527515 C1.90268311,14.1534098 -1.42108547e-14,18.9018028 -1.42108547e-14,23.8979621 C-1.42108547e-14,34.6205 8.77518414,43.344 19.5613044,43.344"/><use fill="#00AECB" xlink:href="#ic_replay_blue_svg__a"/></g></g></g></svg>
          <i
            v-if="isLoading"
            class="el-icon-loading text-blue"/>
        </div>
        <div class="show-content">
          <div class="tags">
            <FreeEpisodeIndicator v-if="isFree" />
            <PremiumIndicator v-if="showPremiumIndicator" />
          </div>
          <div>
            <div>
              <router-link
                :class="{ 'text-gray': currentProgress >= playback }"
                :to="`/listen/${podcast.publisher.slug}/${podcast.slug}/${shows.slug}/${shows.uuid}`"
                data-test="title-episode"
                @click.native="triggerContentSelectEvent">{{ shows.title }}
              </router-link>
              <div
                class="responsive-details"
                data-test="description-episode">
                <span v-if="season_no && episode_no">{{ "S"+(season_no || 0) }} {{ "E"+(episode_no || 0) }}</span>
                <span v-if="shows.released_at">{{ shows.released_at | dateFormat }}</span>
                <span v-if="shows.release_date && !shows.released_at">{{ shows.release_date | dateFormat }}</span>
                <span>{{ episodeRunTime }}</span>
              </div>
            </div>
            <div class="show-image-responsive">
              <!-- <PremiumIndicator v-if="shows.is_exclusive || (shows.season && shows.season.podcast && shows.season.podcast.is_exclusive)" /> -->
              <picture-component
                :src="shows.display_image_url"/>
            </div>
          </div>
          <p
            v-if="shows.description"
            :class="[{'text-gray': currentProgress>=playback || episode_was_played},'description']"
            @click="goToEDP"
          >
            {{ shows.description }}
          </p>
          <div class="responsive-buttons">
            <div class="show-play-button">
              <el-progress
                v-show="playerIcon === playIcon || playerIcon === pauseIcon || isLoading"
                :percentage="Number(currentProgress)"
                :stroke-width="2"
                :width="42"
                :show-text="false"
                type="circle"
                color="#00AECB"
                @click.native="playerIcon === playIcon ? playEpisode() : playerIcon === pauseIcon ? pauseEpisode(): ''"/>
              <svg v-if="playerIcon === playIcon" class="play-button" svg-inline="" @click="playEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 121 156"><defs><path id="ic_play_blue_svg__a" d="M496.406096,345.69723 C491.541695,349.359203 485.132833,350.027479 479.65336,347.444103 C474.173887,344.860725 470.480935,339.429801 470,333.247692 L470,208.752308 C470.480935,202.570199 474.173887,197.139275 479.65336,194.555898 C485.132833,191.972521 491.541695,192.640797 496.406096,196.30277 L584.381047,258.550462 C588.505275,261.268282 591,265.960591 591,271 C591,276.039409 588.505275,280.731718 584.381047,283.449538 L496.406096,345.69723 Z"/></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-470.000000, -193.000000)"><use fill="#00AECB" xlink:href="#ic_play_blue_svg__a"/></g></g></svg>
              <svg v-if="playerIcon === pauseIcon" class="pause-button" svg-inline="" @click="pauseEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 24"><defs><path id="ic_pause_blue_svg__a" d="M611.666667,209 L616.333334,209 C616.885618,209 617.333334,209.447715 617.333334,210 L617.333334,232 C617.333334,232.552285 616.885618,233 616.333334,233 L611.666667,233 C611.114382,233 610.666667,232.552285 610.666667,232 L610.666667,210 C610.666667,209.447715 611.114382,209 611.666667,209 Z M623.666667,209 L628.333334,209 C628.885618,209 629.333334,209.447715 629.333334,210 L629.333334,232 C629.333334,232.552285 628.885618,233 628.333334,233 L623.666667,233 C623.114382,233 622.666667,232.552285 622.666667,232 L622.666667,210 C622.666667,209.447715 623.114382,209 623.666667,209 Z"/></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-610.000000, -209.000000)"><use fill="#00AECB" xlink:href="#ic_pause_blue_svg__a"/></g></g></svg>
              <svg v-if="playerIcon === replayIcon" class="replay-button" svg-inline="" @click="replayEpisode" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 44"><defs><path id="ic_replay_blue_svg__a" d="M17.2802001,31.1473435 C16.7584662,31.5390313 16.0710801,31.6105108 15.4833763,31.3341905 C14.8956726,31.0578702 14.4995829,30.4769738 14.448,29.8157299 L14.448,16.4995939 C14.4995829,15.83835 14.8956726,15.2574536 15.4833763,14.9811333 C16.0710801,14.704813 16.7584662,14.7762925 17.2802001,15.1679803 L26.7160009,21.8260483 C27.1583473,22.1167487 27.4259203,22.6186422 27.4259203,23.1576619 C27.4259203,23.6966816 27.1583473,24.1985751 26.7160009,24.4892755 L17.2802001,31.1473435 Z"/></defs><g fill="none" fill-rule="evenodd"><g><g transform="translate(-595.000000, -200.000000) translate(595.406000, 200.043583)"><path fill="#AFE7F1" d="M19.5613044,43.344 C30.3474247,43.344 39.1225044,34.6205 39.1225044,23.8979621 C39.1225044,18.9986762 37.2823071,14.3166378 33.940987,10.7144563 C30.6028016,7.11589025 26.0708025,4.91502381 21.1798755,4.51742804 L19.8815704,4.41183494 L19.8815704,-3.55271368e-15 L10.9786979,5.31527801 L19.8815704,10.630556 L19.8815704,6.11387235 L21.4359839,6.27593064 C25.7880489,6.72977892 29.8073089,8.76646032 32.7532337,12.0107099 C35.7176535,15.27527 37.3502265,19.4968672 37.3502265,23.8979621 C37.3502265,33.6683544 29.3701171,41.617186 19.5613044,41.617186 C9.7524918,41.617186 1.77238239,33.6683544 1.77238239,23.8979621 C1.77238239,19.3387434 3.50683442,15.0075123 6.65620391,11.702225 C6.81461281,11.5359132 6.89862386,11.3195164 6.89266785,11.0929113 C6.88671185,10.8654555 6.79099776,10.6529932 6.62318464,10.4946567 C6.45004247,10.3313224 6.22810283,10.2502933 6.00668564,10.2502933 C5.76949026,10.2502933 5.53302632,10.3432322 5.35748084,10.527515 C1.90268311,14.1534098 -1.42108547e-14,18.9018028 -1.42108547e-14,23.8979621 C-1.42108547e-14,34.6205 8.77518414,43.344 19.5613044,43.344"/><use fill="#00AECB" xlink:href="#ic_replay_blue_svg__a"/></g></g></g></svg>
              <i
                v-if="isLoading"
                class="el-icon-loading text-blue"/>
            </div>
            <div class="btn-left">
              <div
                v-if="canAddToLibraryBtn"
                class="add-remove-btn">
                <span
                  v-show="deleting_episode || adding_episode"
                  class="processing">
                  <i class="el-icon-loading" />
                  {{ deleting_episode ? 'Deleting..' : adding_episode ? 'Adding..' : '' }}</span>
                <!-- <img
                  v-button-event="{buttonText: addEpisode ? 'Add Episode' : removeEpisode ? 'Remove Episode' : '', contentType: 'episode', contentData: shows}"
                  :src="addEpisode ? addLibraryIcon : removeEpisode ? inLibraryIcon : ''"
                  width="24"
                  @click="addEpisode ? addEpisodeToLibrary(shows.uuid) : removeEpisode ? confirmDeleteEpisode(inUserLibrary.uuid) : ''"> -->
                <div
                  v-button-event="{buttonText: addEpisode ? 'Add Episode' : removeEpisode ? 'Remove Episode' : '', buttonLink: null}"
                  v-if="addEpisode && !removeEpisode"
                  class="svg-btn"
                  @click="addEpisode ? addEpisodeToLibrary(shows.uuid) : removeEpisode ? deleteEpisode(inUserLibrary.uuid) : ''">
                  <svg svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path id="ic_add_episode_svg__a" d="M600,312 C593.372583,312 588,306.627417 588,300 C588,293.372583 593.372583,288 600,288 C606.627417,288 612,293.372583 612,300 C612,306.627417 606.627417,312 600,312 Z M600,311 C606.075132,311 611,306.075132 611,300 C611,293.924868 606.075132,289 600,289 C593.924868,289 589,293.924868 589,300 C589,306.075132 593.924868,311 600,311 Z M603.187502,296.101181 C603.187502,295.696169 602.824102,295.352274 602.357771,295.352274 L597.499183,295.352274 C597.111906,295.352274 596.812498,295.635532 596.812498,295.965812 L596.812498,303.738459 L600.0003,302.026007 L603.187502,303.738459 L603.187502,296.101181 Z M595.460224,306 L595.460224,295.965812 C595.460224,294.871411 596.381318,294 597.499183,294 L602.357771,294 C603.55477,294 604.539776,294.932138 604.539776,296.101181 L604.539776,306 L600.000254,303.561069 L595.460224,306 Z"/></defs><g fill="none" fill-rule="evenodd"><g transform="translate(-588.000000, -288.000000)"><use fill="#00AECB" xlink:href="#ic_add_episode_svg__a"/></g></g></svg>
                </div>
                <div
                  v-button-event="{buttonText: addEpisode ? 'Add Episode' : removeEpisode ? 'Remove Episode' : '', buttonLink: null}"
                  v-if="!addEpisode && removeEpisode"
                  class="svg-btn"
                  @click="addEpisode ? addEpisodeToLibrary(shows.uuid) : removeEpisode ? deleteEpisode(inUserLibrary.uuid) : ''">
                  <svg svg-inline="" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><defs><path id="bookmarked_svg__a" d="M12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 Z M15.1875021,8.10118111 L15.1875021,15.7384592 L12.0003002,14.0260066 L8.81249793,15.7384592 L8.81249793,7.9658124 C8.81249793,7.63553194 9.1119059,7.35227361 9.49918302,7.35227361 L14.3577706,7.35227361 C14.8241018,7.35227361 15.1875021,7.69616922 15.1875021,8.10118111 Z M7.46022432,18 L12.0002543,15.5610686 L16.5397757,18 L16.5397757,8.10118111 C16.5397757,6.93213817 15.5547696,6 14.3577706,6 L9.49918302,6 C8.38131769,6 7.46022432,6.87141091 7.46022432,7.9658124 L7.46022432,18 Z"/></defs><g fill="none" fill-rule="evenodd"><g><g><g><g><mask id="bookmarked_svg__b" fill="white"><use xlink:href="#bookmarked_svg__a"/></mask><g fill="#00AECB" mask="url(#bookmarked_svg__b)"><g transform="translate(-1.090909, -1.090909)"><rect width="25.9324675" height="25.9324675"/></g></g></g></g></g></g></g></svg>
                </div>
                <span
                  v-button-event="{buttonText: addEpisode ? 'Add Episode' : removeEpisode ? 'Remove Episode' : '', buttonLink: null}"
                  v-show="!deleting_episode || !adding_episode"
                  @click="addEpisode ? addEpisodeToLibrary(shows.uuid) : removeEpisode ? deleteEpisode(inUserLibrary.uuid) : ''">
                  {{ addEpisode ? 'Add to Bookmarks' : removeEpisode ? 'Added' : '' }}
                </span>
              </div>
              <span
                v-if="draggableIcon"
                class="border-vertical"/>
              <div
                v-handle
                v-if="draggableIcon"
                class="drag-button">
                <img
                  width="24"
                  src="../assets/images/ic_drag.svg"
                  alt="Drag Button">
              </div>
            </div>
          </div>
          <div
            v-if="canAddToLibraryBtn"
            class="add-remove-btn">
            <span
              v-show="deleting_episode || adding_episode"
              class="processing">
              <i class="el-icon-loading" />
              {{ deleting_episode ? 'Deleting..' : adding_episode ? 'Adding..' : '' }}</span>
            <img
              v-button-event="{buttonText: 'Add Episode', buttonLink: null}"
              :src="addEpisode ? addLibraryIcon : removeEpisode ? inLibraryIcon : ''"
              width="24"
              @click="addEpisode ? addEpisodeToLibrary(shows.uuid) : removeEpisode ? deleteEpisode(inUserLibrary.uuid) : ''">
            <span
              v-show="!deleting_episode || !adding_episode"
              data-test="btnaddtomyShows"
              @click="addEpisode ? addEpisodeToLibrary(shows.uuid) : removeEpisode ? deleteEpisode(inUserLibrary.uuid) : ''">
              {{ addEpisode ? 'Add to Bookmarks' : removeEpisode ? 'Added' : '' }}</span>
          </div>
        </div>
        <div class="show-season">
          <p v-if="season_no && episode_no">{{ "S"+(season_no || 0) }} {{ "E"+(episode_no || 0) }}</p>
        </div>
        <div class="show-date">
          <p v-show="shows.released_at">{{ shows.released_at | dateFormat }}</p>
          <p v-show="shows.release_date && !shows.released_at">{{ shows.release_date | dateFormat }}</p>
        </div>
        <div class="show-duration">
          <p> {{ episodeRunTime }}</p>
        </div>
        <div :class="[{'is-draggable': draggableIcon},'show-image']">
          <picture-component
            :src="shows.display_image_url"/>
        </div>
        <div
          v-handle
          v-if="draggableIcon"
          class="drag-button"
          data-test="drag-button">
          <img
            width="24"
            src="../assets/images/ic_drag.svg"
            alt="Drag Button">
        </div>
      </el-row>
    </div>
    <premium-modal
      v-if="show_premium_modal"
      :show_modal="show_premium_modal"
      @modalClosed="show_premium_modal = false" />
    <login-modal
      v-if="show_login_modal"
      :show_modal="show_login_modal"
      @modalClosed="show_login_modal = false"/>
  </div>
</template>
<script>
import * as log from 'loglevel';
import { HandleDirective } from 'vue-slicksort';
import PremiumContentModal from './PremiumContentModal';
import SegmentEvent from '../services/PlayerEvent';
import Loader from './Loader';
import LoginModal from './LoginModal';
import PremiumIndicator from './PremiumIndicator';
import FreeEpisodeIndicator from './FreeEpisodeIndicator';
import Episode from '../services/Episode';
import Podcast from '../services/Podcast';
import imgPlaceholder from '../assets/images/placeholder.png';
import replayIcon from '../assets/images/ic_replay_blue.svg';
import addLibraryIcon from '../assets/images/ic_add_episode.svg';
import inLibraryIcon from '../assets/images/bookmarked.svg';
import playIcon from '../assets/images/ic_play_blue.svg';
import pauseIcon from '../assets/images/ic_pause_blue.svg';
import freeEpisode from '../assets/images/tag_teal.svg';

export default {
  name: 'ShowCardsList',
  directives: { handle: HandleDirective },
  components: {
    'premium-modal': PremiumContentModal,
    PremiumIndicator,
    FreeEpisodeIndicator,
    LoginModal,
    Loader,
  },
  props: {
    shows: {
      type: Object,
      default: () => {},
    },
    draggableIcon: {
      type: Boolean,
      default: false,
    },
    playlistType: {
      type: String,
      default: 'show',
    },
    showTitle: {
      type: String,
      default: '',
    },
    showDisplayImageUrl: {
      type: String,
      default: '',
    },
    toggleDetail: {
      type: Boolean,
      default: false,
    },
    total_seasons: {
      type: Number,
      default: 0,
    },
    current_season: {
      type: Number,
      default: 0,
    },
    current_episode_index: {
      type: Number,
      default: 0,
    },
    season_no: {
      type: Number,
      default: 0,
    },
    episode_no: {
      type: Number,
      default: 0,
    },
    podcast_meta: {
      type: Object,
      default: () => {},
    },
    podcast: {
      type: Object,
      default: () => {},
    },
    isExclusive: {
      type: Boolean,
      default: false,
    },
    isFree: {
      type: Boolean,
      default: false,
    },
    noBorder: {
      type: Boolean,
      default: () => false,
    },
    bucket: {
      type: Object,
      default: () => {},
    },
    showPremiumIcon: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      imgPlaceholder,
      addLibraryIcon,
      inLibraryIcon,
      playIcon,
      freeEpisode,
      pauseIcon,
      replayIcon,
      episode_service: new Episode(),
      show_service: new Podcast(),
      adding_episode: false,
      deleting_episode: false,
      trim_text: true,
      deleting_show: false,
      showDragCard: false,
      playback: 95,
      episode_was_played: false,
      text_limit: 125,
      title_text_limit: 45,
      record_id_episode: this.shows.record_id,
      is_premium: true,
      show_premium_modal: false,
      show_login_modal: false,
      eventProvider: new SegmentEvent(),
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    isLoggedIn() {
      return this.$store.getters.loggedIn;
    },
    isPremiumMember() {
      return this.user && this.user.is_subscribed;
    },
    canAddToLibraryBtn() {
      return ((this.isLoggedIn && (!this.isExclusive || this.isFree)) || (this.isPremiumMember && this.isExclusive));
    },
    currentProgress() {
      const progress = this.$store.getters.episodeProgressByUuid(this.shows.uuid);

      if (progress) {
        // this.$emit('episode-progress', { uuid: this.shows.uuid, episode_progress: progress });
        return progress.progress_percent;
      }

      return 0;
    },
    isPlaying() {
      const currentlyPlayingEpisode = this.$store.getters.episode;
      const playing = this.$store.getters.play;

      return playing && (currentlyPlayingEpisode && (currentlyPlayingEpisode.uuid === this.shows.uuid));
    },
    isLoading() {
      const { status, episode } = this.$store.getters;
      return status === 'loading' && episode && (episode.uuid === this.shows.uuid);
    },
    showReplayIcon() {
      return ((this.currentProgress >= this.playback || this.episode_was_played) && !this.isLoading);
    },
    inUserLibrary() {
      const userEpisode = this.$store.getters.searchEpisodeInLibrary(this.shows.uuid);
      if (userEpisode && userEpisode.uuid) {
        return userEpisode;
      }
      return null;
    },
    addEpisode() {
      return (!this.inUserLibrary || !this.inUserLibrary.uuid) && !this.adding_episode;
    },
    removeEpisode() {
      return this.inUserLibrary && this.inUserLibrary.uuid && !this.deleting_episode;
    },
    episodeRunTime() {
      return this.currentProgress >= this.playback ? 'Played' : this.$options.filters.humanizedTimeFilter(this.shows.runtime || 0);
    },
    episodeListened() {
      if (this.shows) {
        const progress = this.$store.getters.episodeProgressByUuid(this.shows.uuid);

        if (progress) {
          return progress.progress_percent >= 95;
        }

        return false;
      }

      return false;
    },
    playerIcon() {
      if (this.isLoading) {
        return null;
      }

      if (this.isPlaying) {
        return this.pauseIcon;
      }

      if (this.episodeListened && !this.isPlaying) {
        return this.replayIcon;
      }

      return this.playIcon;

      // const play = this.currentProgress < this.playback && !this.isPlaying && !this.episode_was_played && !this.isLoading ? this.playIcon : '';
      // const pause = this.currentProgress < this.playback && this.isPlaying && !this.episode_was_played && !this.isLoading ? this.pauseIcon : '';
      // const replay = ((this.currentProgress >= this.playback || this.episode_was_played) && !this.isLoading) ? this.replayIcon : '';
      // return play || pause || replay;
    },
    showPremiumIndicator() {
      if (this.shows.is_exclusive || (this.shows.season && this.shows.season.podcast && this.shows.season.podcast.is_exclusive)) {
        if (!this.isFree && !this.isPremiumMember) {
          return true;
        }

        if (this.isPremiumMember) {
          return true;
        }
      }

      return false;
    },
  },
  mounted() {
    // this.textDescriptionLimit();
    const ctx = this;
    let isScrolling;
    this.scrollListener = function () {
      window.clearTimeout(isScrolling);
      isScrolling = setTimeout(() => {
        ctx.checkIfVisible();
      }, 66);
    };
    document.body.addEventListener('scroll', this.scrollListener);
    this.checkIfVisible();
  },
  destroyed() {
    document.body.removeEventListener('scroll', this.scrollListener);
  },
  methods: {
    checkIfVisible() {
      const viewportHeight = document.body.offsetHeight;
      const element = this.$refs['show-card-list'];
      if (element) {
        const elementRect = element.getBoundingClientRect();
        const elementPos = elementRect.top;
        const threshold = (element.offsetHeight / 3); // part of element within viewport
        const isVisible = elementPos >= (-1 * threshold) && (elementPos + threshold) <= viewportHeight;
        if (isVisible && this.shows.uuid.length > 1) {
          element.classList.add('is-visible');
        }
      }
    },
    textDescriptionLimit() {
      if (window.innerWidth <= 567) {
        this.text_limit = 125;
        this.title_text_limit = 40;
      } else if (window.innerWidth <= 768) {
        this.text_limit = 70;
        this.title_text_limit = 25;
      } else if (window.innerWidth <= 1024) {
        this.text_limit = 75;
        this.title_text_limit = 40;
      } else if (window.innerWidth <= 1280) {
        this.text_limit = 75;
        this.title_text_limit = 50;
      }
    },
    detailsClicked() {
      this.$emit('details', 1);
      this.trim_text = !this.trim_text;
    },
    closesPremiumModal() {
      this.show_premium_modal = false;
    },
    playEpisode() {
      this.shows.screen_name = this.bucket.screen_name;
      // If user is not premium and show is exclusive, then show PremiumContentDialog.
      this.show_premium_modal = (!this.user && this.shows.is_exclusive) || (this.user && !this.user.is_subscribed && this.shows.is_exclusive);
      if (this.show_premium_modal) return;

      this.loadMediaInPlayer(this.shows.media_url, this.shows.is_exclusive);

      this.episode_was_played = false;
      this.$store.dispatch('setPlaylistType', this.playlistType);
      this.shows.show_title = this.showTitle ? this.showTitle : '';

      this.shows.meta = {
        podcast_meta: this.podcast_meta,
        current_episode_index: this.current_episode_index,
        total_seasons: this.total_seasons,
        current_season: this.current_season,
      };

      this.shows.show_title = this.showTitle;
      this.shows.display_image_url = this.shows.image_url ? this.shows.display_image_url : this.showDisplayImageUrl;
      // this.playPodcast(this.shows)
      // Play episode using central store
      const currentEpisode = this.$store.getters.episode;

      if (currentEpisode.uuid === this.shows.uuid) {
        this.$store.dispatch('play');
        this.eventProvider.triggerEpisodePlayEvent(this.shows, 'resume_episode');
      } else {
        if (currentEpisode && currentEpisode.uuid) {
          this.eventProvider.triggerEpisodePauseEvent(currentEpisode, 'episode_select');
        }
        this.$store.dispatch('setAndPlayEpisode', this.shows);
        this.eventProvider.triggerEpisodePlayEvent(this.shows, 'press_play');
      }
      this.$store.commit('setContinuousListeningActivePodcast', this.shows.season.podcast.uuid);
    },
    pauseEpisode() {
      this.episode_was_played = false;
      // window.eventBus.$emit("pause-podcast",{})
      this.$store.dispatch('pause');
      this.eventProvider.triggerEpisodePauseEvent(this.shows, 'pause');
    },
    replayEpisode() {
      this.$store.dispatch('setProgress', 0);
      this.playEpisode();
    },
    addEpisodeToLibrary(id) {
      // If user is not premium and show is exclusive, then show PremiumContentDialog.
      this.show_premium_modal = this.user && !this.user.is_subscribed && this.shows.is_exclusive;
      if (this.show_premium_modal) return;
      this.adding_episode = true;
      this.episode_service.addEpisodetoLibrary(id).then((res) => {
        this.adding_episode = false;
        if (res && res.success) {
          this.$store.dispatch('setUserLibraryEpisode', { uuid: res.uuid, episode_uuid: id });
          this.$set(this.shows, 'record_id', res.uuid);
          this.shows.in_library = true;
          // this.showSuccessMsg('Episode Added to Library');
          this.eventProvider.triggerEpisodeAddEvent(this.shows);
        } else {
          this.showErrorMsg('Failed to add episode to your library!');
        }
      }).catch((err) => {
        this.$emit('added', 0);
        this.adding_episode = false;
        this.showErrorMsg('Failed to add episode to your library!');
        log.error(err.message);
      });
    },
    deleteEpisode(delId) {
      this.deleting_episode = true;
      this.episode_service
        .deleteEpisodeFromLibrary(delId)
        .then((res) => {
          this.deleting_episode = false;
          if (res && res.success) {
            this.$store.dispatch('removeUserLibraryEpiosde', this.shows.uuid);
            this.$emit('deleted', this.shows.uuid);

            // this.showSuccessMsg('Episode deleted from your library.');
            this.shows.in_library = false;
            this.eventProvider.triggerEpisodeRemoveEvent(this.shows);
          } else {
            this.$emit('deleted', 0);

            this.showErrorMsg('Couldn\'t delete this episode from your library. Please try again.');
          }
        })
        .catch(() => {
          this.$emit('deleted', 0);
          this.deleting_episode = false;

          this.showErrorMsg('Couldn\'t delete this episode from your library. Please try again.');
          // this.$notify.error({
          //   title: 'Error',
          //   message: "Couldn't delete this episode from your library. Please try again.",
          // });
        });
    },
    showProgress(progress, runtime) {
      return (progress && runtime) ? ((progress / runtime) * 100).toFixed(2) : 0;
    },
    deleteShow(id) {
      this.deleting_show = true;
      this.show_service
        .deletePodcastFromLibrary(id)
        .then(() => {
          this.$emit('deleted', id);
          this.deleting_show = false;
        })
        .catch(() => {
          this.$emit('deleted', 0);
          this.deleting_show = false;
        });
    },
    onVisibleInViewport() {
      const ele = document.querySelector(`.show-card-list[data-segment-uuid="${this.shows.uuid}"]`);
      if (ele) {
        ele.classList.add('is-visible');
      }
    },
    triggerContentSelectEvent() {
      const bucketItemData = { ...this.shows };
      bucketItemData.item_position = this.$vnode.key;
      delete bucketItemData.podcast;

      this.eventProvider.triggerContentSelectEvent(this.bucket, bucketItemData);
    },
    goToEDP() {
      this.$router.push(`/listen/${this.podcast.publisher.slug}/${this.podcast.slug}/${this.shows.slug}/${this.shows.uuid}`);
    },
  },
};
</script>
<style scoped lang="scss">
// THE CSS BELOW IS VERY SENSITIVE. DON'T ALTER IT UNLESS IT'S ABSOLUTEY NECESSARY !!!
  @import "../assets/scss/variables.scss";
  @import "../assets/scss/mixins.scss";
  ::selection {
    opacity: 0 !important;
  }
  .show-card-list {
    padding: 18px 60px 0;
    background-color: $xxlight-gray;
    border-radius: 0px;
    &:hover {
      background-color: $light-blue;
      cursor: pointer;
    }
    .draggable-element {
      display: none;
      width: 360px;
      height: 80px;
      align-items: center;
      z-index: 3;
      padding: .5rem;
      border-radius:10px;
      background-color: #fff !important;
      box-shadow: 0px 0px 10px 6px rgba(200,200,200,.3);
      .picture-component {
        width:80px;
        height: 80px;
      }
      p {
        margin:0 15px;
        width: auto;
        display: inline-block;
      }
    }
    .main-content {
      border-bottom: 1px solid $xlight-gray;
      padding-bottom: 18px;
      position: relative;
      &.without-border {
        border-bottom: none;
      }

      .tags {
        position: relative;
        left: 122px;
        margin-bottom: 8px;

        @media (max-width: 1200px) {
          left: 102px;
        }

        @media (max-width: 1024px) {
          left: 70px;
        }

        @media (max-width: 768px) {
          left: 74px;
        }

        @media (max-width: 576px) {
          display: none;
        }
      }

      .show-play-button {
        display: flex;
        align-items: center;
        margin-left: 30px;
        min-width: 46px;
        visibility: visible !important;
        > div {
          cursor: pointer;
        }
        img, svg {
          cursor: pointer;
          visibility: visible !important;
          &.play-button {
            position: absolute;
            left: 43px;
            width: 20px;
            height: 20px;
          }
          &.pause-button {
            position: absolute;
            left: 43px;
            width: 16px;
            height: 16px;
          }
          &.replay-button {
            width: 46px;
            height: 46px;
          }
        }
        i {
          position: absolute;
          left: 41px;
          font-size: 20px;
        }
      }
      .show-content {
        flex: 1;
        max-width: 530px;
        margin: 0 15px 0 40px;
        .tags {
          display: none;
        }
        a {
          color: $black ;
          display: block;
          @include multilinetruncate(20px,24px,1);
          &:hover {
            text-decoration: underline;
          }
        }
        .description {
          color: $black;
          margin-bottom: 0 !important;
          @include multilinetruncate(14px, 18px, 2);
        }
        .responsive-details,.show-image-responsive, .responsive-buttons {
          display: none;
        }
        .add-remove-btn {
          display: flex;
          align-items: center;
          margin-top: 10px;
          font-family: Favorit-light;
          img, span {
            cursor: pointer;
          }
          .processing {
            display: flex;
            align-items: center;
            color: $blue;
            font-size: 16px;
            i {
              font-size: 24px;
              margin-right: 12px;
              color: $blue;
            }
          }
          span:not(.processing) {
            margin-left: 12px;
            color: $blue;
          }
          div, svg {
            width: 24px;
            height: 24px;
          }
        }
      }
      .show-season, .show-date, .show-duration {
        flex: 1;
        margin: 0 15px;
        max-width: 80px;
        p {
          margin: 0 0 !important;
          color: $gray;
          font-size: 14px;
          text-align: right;
        }
      }
      .show-date {
        max-width: 90px !important;
      }
      .show-duration {
        max-width: 85px;
      }
      .show-image {
        width: 86px;
        height: 86px;
        margin: 0 35px 0 95px;
        position: relative;
        cursor: pointer;
        &:not(.is-draggable) {
          margin-right: 0 !important;
        }
      }
      .drag-button {
        display: flex;
        align-items: center;
        img {
          &:hover {
            cursor: move;
          }
        }
      }
    }
    .border {
      background: $xlight-gray;
      height: 1px;
    }
  }
  @media (max-width: $lg) {
    .show-card-list {
      .main-content {
        .show-content {
          margin: 0 10px 0 30px;
          .show-image-responsive {
            display: none;
          }
        }
        .show-season {
          margin-left: 0 !important;
        }
        .show-season, .show-date, .show-duration {
          // margin: 0 15px;
        }
        .show-image {
          margin: 0 15px 0 15px !important;
        }
      }
    }
  }
  @media (max-width: $md) {
    .show-card-list {
      padding: 12px 44px 0 30px;
      .main-content {
        .show-play-button {
          margin-left: 10px;
          img,svg {
            left: 23px !important;
          }
          i {
            left: 21px !important;
          }
        }
       .show-content {
         flex:1;
         margin: 0 5px 0 20px;
       }
       .show-season, .show-date,.show-duration {
         margin: 0 5px;
       }
       .show-image {
         margin: 0 0 0 30px !important;
         &.is-draggable {
           margin-right: 15px !important;
         }
       }
      }
    }
  }
  @media (max-width: $sm) {
    .show-card-list {
      padding: 12px 44px 0 30px;
      .main-content {
        .show-play-button {
          margin-left: 5px;
          img , svg {
            left: 18px !important;
          }
          i {
            left: 16px !important;
          }
        }
        .show-content {
          max-width: unset;
          margin: 0 20px 0 30px;
          a {
            font-size: 18px;
            line-height: 22px;
            font-family: Favorit;
            font-weight: 500;
          }
          .responsive-details {
            display: block;
            margin: 5px 0;
            span {
              line-height: 10px;
              color: $gray;
              font-size: 14px;
              &:nth-child(1) {
                padding-right: 5px;
              }
              &:nth-child(2) {
                padding: 0 8px;
                border-left: 1px solid $gray;
                border-right:1px solid $gray;
              }
              &:nth-child(3) {
                padding-left: 5px;
              }
            }
          }
          .description {
            height: 36px;
          }
        }
        .show-season, .show-date, .show-duration {
          display: none;
        }
        .show-image {
          margin: 0 37px 0 27px !important;
        }
      }
    }
  }
  @media (max-width: $xs) {
    .show-card-list {
      padding: 12px 30px 0 30px;
      .main-content {
        .tags {
          display: none;
          left: 0;
        }
        .show-play-button {
          margin-left: 0 !important;
        }
       .show-play-button, .show-image {
         display: none;
       }
       .show-content {
         margin: 0 0;
         .tags {
           display: block;
           left: 0;
         }
         .add-remove-btn {
           display: none;
           margin-top: 0 !important;
         }
         >div {
           display: flex;
           justify-content: space-between;
           >div {
            a {
              font-size: 16px;
              line-height: 21px;
              height: 42px;
            }
           }
          .show-image-responsive {
            display: block;
            position: relative;
            img {
              width: 76px;
              height: 76px;
            }
          }
         }
         .responsive-details {
           span {
             font-size: 11px;
           }
         }
         .description {
           margin-top: 0;
           height: 54px;
         }
         .responsive-buttons {
           display: flex !important;
           justify-content: space-between;
           align-items: center;
           .show-play-button {
             display: block;
             margin-top: 10px;
              .play-button {
                bottom: 17px;
                left: 12px !important;
              }
              .pause-button {
                bottom: 18px;
                width: 16px;
                height: 16px;
                left: 13px !important;
              }
              i {
                bottom: 16px;
                left: 11px !important;
              }
           }
           .btn-left {
              display: flex !important;
              justify-content: space-between;
              align-items: center;
              .add-remove-btn {
                display: flex;
                span {
                  margin-left: 10px;
                  font-family: Favorit-light;
                }
              }
              .border-vertical {
                width: 1px;
                height:24px;
                margin:0 15px;
                background-color: $xlight-gray;
              }
              .drag-button {
                display: block !important;
                img {
                  margin-top:5px;
                }
              }
           }
         }
       }
      }
      .drag-button {
        display: none !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// app/src/components/CardList.vue